/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ConfigurationInputs */

const en_configuration = /** @type {(inputs: ConfigurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuration`)
};

const fr_configuration = /** @type {(inputs: ConfigurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuration`)
};

const de_configuration = /** @type {(inputs: ConfigurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konfiguration`)
};

const it_configuration = /** @type {(inputs: ConfigurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurazione`)
};

const ru_configuration = /** @type {(inputs: ConfigurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Конфигурация`)
};

const es_configuration = /** @type {(inputs: ConfigurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración`)
};

const zh_cn2_configuration = /** @type {(inputs: ConfigurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配置`)
};

const ja_configuration = /** @type {(inputs: ConfigurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`構成`)
};

const hi_configuration = /** @type {(inputs: ConfigurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विन्यास`)
};

const pt_pt2_configuration = /** @type {(inputs: ConfigurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuração`)
};

/**
* | output |
* | --- |
* | "Configuration" |
*
* @param {ConfigurationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const configuration = /** @type {((inputs?: ConfigurationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ConfigurationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_configuration(inputs)
	if (locale === "de") return de_configuration(inputs)
	if (locale === "it") return it_configuration(inputs)
	if (locale === "ru") return ru_configuration(inputs)
	if (locale === "es") return es_configuration(inputs)
	if (locale === "zh-CN") return zh_cn2_configuration(inputs)
	if (locale === "ja") return ja_configuration(inputs)
	if (locale === "hi") return hi_configuration(inputs)
	if (locale === "pt-PT") return pt_pt2_configuration(inputs)
	return en_configuration(inputs)
});